/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-11 16:55:04
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-23 09:50:34
 * @name: 通用-获取手机验证码
 * @Description: 通用-获取手机验证码
 * @FilePath: \project\src\module\common\validator\verify.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'mobile',
    description: '手机号',
    required: true,
    required_message: '手机号为必填项',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请输入手机号';
      } else if (!(e.length === 11 && /^\d+$/.test(e))) {
        return '手机号格式错误';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'scene',
    description: '场景  pwd_verify修改密码',
    required: true,
    required_message: '场景为必填项',
    match: (e) => {
      return '';
    }
  },
]